import MessageList from "./MessageList"
import Sender from "./Sender"

export default function Conversation({
  title,
  subtitle,
  messages,
  loaderVisible,
  inputDisabled,
  handleNewUserMessage,
  toolbarSlot,
  children,
}) {
  return (
    <div className="chatbot-widget-conversation">
      <header className="chatbot-widget-header">
        <div className="chatbot-widget-header-text">
          {title && <h4>{title}</h4>}
          {subtitle && <span>{subtitle}</span>}
        </div>
        {toolbarSlot && <div className="chatbot-widget-header-toolbar">{toolbarSlot}</div>}
      </header>
      <MessageList messages={messages} loaderVisible={loaderVisible} />
      <Sender inputDisabled={inputDisabled} handleNewUserMessage={handleNewUserMessage}>
        {children}
      </Sender>
    </div>
  )
}
